import { useLocation } from "react-router-dom";

export type Lang = "fr" | "es" | "nl" | "de" | "en" | "it" | "pt";

type Dict = Record<string, string>;

const fr: Dict = {
  // Header
  "header.discuter": "Discuter",
  "header.discuter_aria": "Discuter avec Célia",
  "header.prendre_rdv": "Prendre rdv",
  "header.prendre_rdv_aria": "Prendre rendez-vous avec Célia",
  "header.demande_short": "Demande",
  "header.envoyer_demande": "Envoyer ma demande",
  "header.plateforme_short": "Plateforme",
  "header.plateforme_full": "Accéder à la plateforme Veolia",
  "header.pill_role": ", votre conseillère ",
  "header.pill_role_suffix": "",

  // Helmet
  "seo.title": "Naboo × Veolia — Plateforme événementielle dédiée aux collaborateurs Veolia",
  "seo.description": "Plateforme Naboo réservée exclusivement aux collaborateurs Veolia : organisez vos séminaires, événements et team building avec des conditions négociées et un accompagnement dédié par Célia.",
  "seo.og.description": "Espace privé Veolia × Naboo : organisez vos séminaires et événements d'entreprise avec tarifs négociés et accompagnement dédié. Réservé aux équipes Veolia.",
  "seo.og.image_alt": "Logos Veolia et Naboo — Votre plateforme événementielle dédiée",
  "seo.twitter.title": "Naboo × Veolia — Plateforme événementielle dédiée",
  "seo.twitter.description": "Espace privé Veolia × Naboo : séminaires, événements et team building avec tarifs négociés et conseillère dédiée.",
  "seo.twitter.image_alt": "Naboo × Veolia — Plateforme événementielle dédiée",
  "seo.author": "Naboo pour Veolia",
  "seo.locale": "fr_FR",
  "html.lang": "fr",

  // Hero
  "hero.badge": "Quiz",
  "hero.title": "Quelques questions rapides pour trouver votre lieu idéal.",
  "hero.step.type": "Type d'événement",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Votre match",
  "hero.cta": "Démarrer →",
  "hero.subline": "Résultats en moins de 30 sec",

  // Stats
  "stats.partnership_value": "7 ans",
  "stats.partnership": "Partenaire depuis",
  "stats.events": "Événements",
  "stats.participants": "Participants",
  "stats.colleagues": "Collègues inscrits",

  // Colleagues
  "colleagues.title": "Déjà 752 collègues Veolia sont inscrits sur Naboo",
  "colleagues.paragraph": "Retrouvez l'historique de vos événements, le suivi de vos projets en cours et tous vos devis au même endroit.",
  "colleagues.cta": "Créer un compte →",
  "colleagues.label": "Vos collègues utilisent déjà Naboo",
  "colleagues.more": "collègues",

  // Top destinations
  "destinations.title": "Top destinations",
  "destinations.instant": "Réservation instantanée",
  "destinations.bottom_title": "Découvrez plus de 50 000 lieux et prestataires dans notre base de données",
  "destinations.bottom_subtitle": "Explorez l'ensemble du catalogue Naboo réservé aux équipes Veolia.",
  "destinations.bottom_cta": "Explorer les lieux →",

  // Push
  "push.line1": "Votre lieu idéal en 30 sec",
  "push.line2": "Quiz Naboo",
  "push.close": "Fermer",

  // Events
  "events.title": "Organisez tout type d'événement, de 5 à 500 participants, partout dans le monde",
  "events.prev": "Précédent",
  "events.next": "Suivant",
  "events.go_to": "Aller à l'événement",
  "events.stay": "Séjour avec nuitée",
  "events.conf": "Conférences",
  "events.rooms": "Réservation de chambres pour expositions et salons",
  "events.awayday": "Journée externe | Réunion | Session de formation",
  "events.parties": "Soirées d'entreprise | Afterworks",
  "events.meals": "Repas d'affaires | Traiteur",
  "events.tb": "Activité team building",

  // Services
  "services.title": "Une seule plateforme pour toute votre logistique",
  "services.paragraph": "De la salle de réunion au bus de transfert, on s'occupe de tout. Vous n'avez qu'un seul interlocuteur : Célia.",
  "services.catering": "Restauration & traiteurs",
  "services.animation": "Animation & speakers",
  "services.transport": "Transport & transferts",
  "services.hotels": "Hôtels & lieux",
  "services.coworking": "Salles & coworking",
  "services.more": "+ tout autre service événementiel sur demande",

  // Preferred terms
  "pt.title": "Bénéficiez de conditions préférentielles",
  "pt.col.invoicing": "Portage de factures",
  "pt.col.standard": "Service Standard",
  "pt.col.turnkey": "Service Clé en Main",
  "pt.group.admin": "Admin",
  "pt.group.search": "Recherche de lieu",
  "pt.group.management": "Gestion d'événement",
  "pt.row.fees": "Frais",
  "pt.row.advance": "Avance d'acompte",
  "pt.row.referencing": "Référencement de nouveaux lieux et prestataires via Naboo",
  "pt.row.autonomy": "Autonomie complète sur la plateforme",
  "pt.row.delegation": "Délégation du brief à un expert événementiel avec suggestions et support illimités",
  "pt.row.assistance": "Assistance illimitée pour négocier les prix et conditions",
  "pt.row.app": "Application événementielle pour organisateurs et participants",
  "pt.row.visit": "Visite du site",
  "pt.row.coordination": "Coordination des prestataires après signature du devis",
  "pt.row.onsite": "Gestionnaire d'événement sur place pendant l'événement (>40K€)",
  "pt.discover_fees": "Découvrez nos frais",
  "pt.cta": "Découvrir la plateforme Veolia",

  // How to
  "how.badge": "En 6 étapes simples",
  "how.title": "Comment faire ?",
  "how.step": "Étape",
  "how.of": "/",
  "how.prev": "Étape précédente",
  "how.next": "Étape suivante",
  "how.go_to": "Aller à l'étape",
  "how.s1.title": "Envoyez votre brief",
  "how.s1.desc": "Envoyez votre brief à votre expert événementiel (via la plateforme, par email ou par téléphone) ou recherchez en utilisant la barre de recherche en toute autonomie.",
  "how.s1.link.platform": "Lien vers la plateforme",
  "how.s2.title": "Obtenez une réponse rapide",
  "how.s2.desc": "Votre expert événementiel répond dans l'heure, fait les premières suggestions dans les 2 heures et finalise vos devis dans les 2 jours.",
  "how.s3.title": "Demandez des ajustements",
  "how.s3.desc": "Demandez des ajustements ou de nouvelles propositions. Votre expert met tout à jour dans les 24 heures jusqu'à ce que vous soyez prêt à confirmer votre réservation. Les ajustements sont illimités.",
  "how.s4.title": "Confirmez la réservation",
  "how.s4.desc": "Quand vous êtes satisfait de vos devis, téléchargez le devis qui correspond à vos attentes et lancez votre processus de demande d'achat.",
  "how.s5.title": "Créez votre demande d'achat",
  "how.s5.desc": "Pendant la validation de votre demande d'achat, cliquez sur 'Confirmer la réservation' sur la plateforme pour télécharger la facture finale et transformer votre demande d'achat en bon de commande. Naboo s'occupe de tout.",
  "how.s6.title": "Obtenez un support complet (optionnel)",
  "how.s6.desc": "Si vous avez besoin d'aide pour organiser votre événement, Naboo peut vous fournir un support complet de gestionnaire d'événement jusqu'au jour de l'événement, il suffit de demander !",

  // Footer
  "footer.terms": "Conditions générales d'utilisation",
  "footer.cgu": "CGU",
  "footer.contact": "Contactez-nous",
  "footer.cookies": "Modifier vos préférences de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  // Popover
  "pop.subject": "Demande Veolia",
  "pop.copy": "Copier l'email",
  "pop.gmail": "Ouvrir dans Gmail",
  "pop.outlook": "Ouvrir dans Outlook",
  "pop.mail_app": "Utiliser mon application mail",
  "pop.copied": "Email copié",
  "pop.copy_error": "Impossible de copier",

  // Lang
  "lang.fr": "FR",
  "lang.es": "ES",
  "lang.nl": "NL",
  "lang.de": "DE",
  "lang.en": "EN",

  // Quiz
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Catégories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.title.type": "Quel type d'événement organisez-vous ?",
  "quiz.title.categories": "Quelle ambiance recherchez-vous ?",
  "quiz.title.participants": "Combien de participants ?",
  "quiz.title.standing": "Quel est votre budget ?",
  "quiz.title.dates_prefix": "Quand a lieu votre ",
  "quiz.title.dates_suffix": " ?",
  "quiz.title.event_word": "événement",
  "quiz.label.0": "Type d'événement",
  "quiz.label.1": "Dates",
  "quiz.label.2": "Catégories",
  "quiz.label.3": "Participants",
  "quiz.label.4": "Budget",
  "quiz.label.5": "Vos coordonnées",
  "quiz.month.0": "Janvier",
  "quiz.month.1": "Février",
  "quiz.month.2": "Mars",
  "quiz.month.3": "Avril",
  "quiz.month.4": "Mai",
  "quiz.month.5": "Juin",
  "quiz.month.6": "Juillet",
  "quiz.month.7": "Août",
  "quiz.month.8": "Septembre",
  "quiz.month.9": "Octobre",
  "quiz.month.10": "Novembre",
  "quiz.month.11": "Décembre",
  "quiz.evt.seminaire": "Séminaire d'entreprise",
  "quiz.evt.journee_hors_site": "Journée hors site",
  "quiz.evt.soiree": "Soirée d'entreprise",
  "quiz.evt.team_building": "Activité team building",
  "quiz.evt.conference": "Conférence",
  "quiz.evt.lancement_produit": "Lancement de produit",
  "quiz.evt.autre": "Autre",
  "quiz.evt.placeholder": "Précisez le type d'événement",
  "quiz.cat.Plage": "Plage",
  "quiz.cat.Montagne": "Montagne",
  "quiz.cat.Ville": "Ville",
  "quiz.cat.Nature": "Nature",
  "quiz.cat.Désert": "Désert",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Bord de lac",
  "quiz.cat.Île": "Île",
  "quiz.cat.Historique": "Historique",
  "quiz.cat.Luxe": "Luxe",
  "quiz.cat.Aventure": "Aventure",
  "quiz.cat.Bien-être": "Bien-être",
  "quiz.dates.placeholder": "Choisir une date",
  "quiz.dates.or_month": "Ou choisissez un mois",
  "quiz.participants.hint": "Nombre de participants",
  "quiz.participants.placeholder": "Ex : 25",
  "quiz.budget.per_person": "soit {p} € par personne",
  "quiz.budget.or": "OU",
  "quiz.budget.placeholder": "Budget total exact",
  "quiz.budget.exact": "Saisir un montant exact",
  "quiz.standing.Essentiel": "Essentiel",
  "quiz.standing.Confort": "Confort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestige",
  "quiz.standing.Exception": "Exception",
  "quiz.match.title": "Recevez vos suggestions",
  "quiz.match.subtitle": "Indiquez votre email professionnel pour recevoir votre sélection personnalisée.",
  "quiz.match.email_placeholder": "votre.email@veolia.com",
  "quiz.match.cta": "Recevoir mes suggestions",
  "quiz.match.sending": "Envoi en cours…",
  "quiz.match_suffix": "% de match",
  "quiz.email.required": "Email requis",
  "quiz.email.invalid": "Email invalide",
  "quiz.email.pro": "Merci d'utiliser votre email professionnel",
  "quiz.success.title": "Demande envoyée !",
  "quiz.success.subtitle": "Célia revient vers vous très rapidement avec une sélection personnalisée.",
  "quiz.success.close": "Fermer",
  "quiz.engagement.title": "Comment souhaitez-vous recevoir vos suggestions ?",
  "quiz.engagement.subtitle": "Plus qu'une étape",
  "quiz.engagement.email_title": "Par email",
  "quiz.engagement.email_desc": "Directement dans votre boîte mail sous 2 heures.",
  "quiz.engagement.email_b1": "Recevez un récapitulatif de votre brief",
  "quiz.engagement.email_b2": "Obtenez des recommandations sur-mesure",
  "quiz.engagement.email_b3": "Réservez votre événement en toute autonomie",
  "quiz.engagement.email_cta": "Recevoir par email",
  "quiz.engagement.rdv_title": "Lors d'un échange avec Célia",
  "quiz.engagement.rdv_desc": "Uniquement de vraies recommandations.",
  "quiz.engagement.rdv_b1": "Sans engagement",
  "quiz.engagement.rdv_b2": "Un vrai humain, pas un bot",
  "quiz.engagement.rdv_b3": "100 % adapté à vos besoins",
  "quiz.engagement.rdv_cta": "Réserver un créneau",
  "quiz.engagement.rdv_modal_title": "Réserver un créneau avec Célia",
  "quiz.engagement.rdv_success_title": "Rendez-vous confirmé !",
  "quiz.engagement.rdv_success_subtitle": "Célia vous contactera au créneau choisi. Une invitation est dans votre boîte mail.",
  "quiz.nav.back": "Retour",
  "quiz.nav.next": "Suivant",
  "quiz.aria.close": "Fermer",
  "quiz.tier.Petit comité": "Petit comité",
  "quiz.tier.Groupe convivial": "Groupe convivial",
  "quiz.tier.Grande équipe": "Grande équipe",
  "quiz.tier.Grand événement": "Grand événement",
  "quiz.tier.Événement XL": "Événement XL",

  // AI Planner
  "ai_planner.pill": "Nouveau · IA",
  "ai_planner.title": "Construisons votre prochain événement",
  "ai_planner.description": "Décrivez votre événement et notre IA vous suggérera des options personnalisées.",
  "ai_planner.cta": "Essayer l'IA planner",
};

const es: Dict = {
  ...fr,
  "header.discuter": "Conversar",
  "header.discuter_aria": "Conversar con Célia",
  "header.prendre_rdv": "Reservar cita",
  "header.prendre_rdv_aria": "Reservar una cita con Célia",
  "header.demande_short": "Solicitud",
  "header.envoyer_demande": "Enviar mi solicitud",
  "header.plateforme_short": "Plataforma",
  "header.plateforme_full": "Acceder a la plataforma Veolia",
  "header.pill_role": ", su asesora ",
  "header.pill_role_suffix": "",

  "seo.title": "Naboo × Veolia — Plataforma de eventos dedicada a los colaboradores de Veolia",
  "seo.description": "Plataforma Naboo reservada exclusivamente a los colaboradores de Veolia: organice sus seminarios, eventos y team building con condiciones negociadas y un acompañamiento dedicado por Célia.",
  "seo.og.description": "Espacio privado Veolia × Naboo: organice sus seminarios y eventos con tarifas negociadas y acompañamiento dedicado.",
  "seo.og.image_alt": "Logos Veolia y Naboo — Su plataforma de eventos dedicada",
  "seo.twitter.title": "Naboo × Veolia — Plataforma de eventos dedicada",
  "seo.twitter.description": "Espacio privado Veolia × Naboo: seminarios, eventos y team building con tarifas negociadas y asesora dedicada.",
  "seo.twitter.image_alt": "Naboo × Veolia — Plataforma de eventos dedicada",
  "seo.author": "Naboo para Veolia",
  "seo.locale": "es_ES",
  "html.lang": "es",

  "hero.badge": "Quiz",
  "hero.title": "Algunas preguntas rápidas para encontrar su lugar ideal.",
  "hero.step.type": "Tipo de evento",
  "hero.step.dates": "Fechas",
  "hero.step.participants": "Participantes",
  "hero.step.match": "Su match",
  "hero.cta": "Empezar →",
  "hero.subline": "Obtén resultados en menos de 30 seg",

  "stats.partnership_value": "7 años",
  "stats.partnership": "Socio desde",
  "stats.events": "Eventos",
  "stats.participants": "Participantes",
  "stats.colleagues": "Colaboradores registrados",

  "colleagues.title": "Ya hay 752 personas colaboradoras de Veolia registrados en Naboo",
  "colleagues.paragraph": "Encuentre el historial de sus eventos, el seguimiento de sus proyectos en curso y todos sus presupuestos en un mismo lugar.",
  "colleagues.cta": "Crear una cuenta →",
  "colleagues.label": "Sus colaboradores ya utilizan Naboo",
  "colleagues.more": "colaboradores",

  "destinations.title": "Destinos destacados",
  "destinations.instant": "Reserva instantánea",
  "destinations.bottom_title": "Descubra más de 50 000 lugares y proveedores en nuestra base de datos",
  "destinations.bottom_subtitle": "Explore todo el catálogo Naboo reservado a los equipos de Veolia.",
  "destinations.bottom_cta": "Explorar los lugares →",

  "push.line1": "Su lugar ideal en 30 seg",
  "push.line2": "Quiz Naboo",
  "push.close": "Cerrar",

  "events.title": "Organice cualquier tipo de evento, de 5 a 500 participantes, en cualquier lugar del mundo",
  "events.prev": "Anterior",
  "events.next": "Siguiente",
  "events.go_to": "Ir al evento",
  "events.stay": "Estancia con noche",
  "events.conf": "Conferencias",
  "events.rooms": "Reserva de habitaciones para exposiciones y ferias",
  "events.awayday": "Jornada externa | Reunión | Sesión de formación",
  "events.parties": "Fiestas de empresa | Afterworks",
  "events.meals": "Comidas de negocios | Catering",
  "events.tb": "Actividad de team building",

  "services.title": "Una sola plataforma para toda su logística",
  "services.paragraph": "De la sala de reuniones al bus de transferencia, nos ocupamos de todo. Solo tiene un interlocutor: Célia.",
  "services.catering": "Restauración y catering",
  "services.animation": "Animación y ponentes",
  "services.transport": "Transporte y transferencias",
  "services.hotels": "Hoteles y lugares",
  "services.coworking": "Salas y coworking",
  "services.more": "+ cualquier otro servicio de eventos a petición",

  "pt.title": "Benefíciese de condiciones preferentes",
  "pt.col.invoicing": "Gestión de facturas",
  "pt.col.standard": "Servicio Estándar",
  "pt.col.turnkey": "Servicio Llave en Mano",
  "pt.group.admin": "Admin",
  "pt.group.search": "Búsqueda de lugar",
  "pt.group.management": "Gestión de eventos",
  "pt.row.fees": "Tarifas",
  "pt.row.advance": "Anticipo",
  "pt.row.referencing": "Referenciación de nuevos lugares y proveedores vía Naboo",
  "pt.row.autonomy": "Autonomía completa en la plataforma",
  "pt.row.delegation": "Delegación del brief a un experto en eventos con sugerencias y soporte ilimitados",
  "pt.row.assistance": "Asistencia ilimitada para negociar precios y condiciones",
  "pt.row.app": "Aplicación de eventos para organizadores y participantes",
  "pt.row.visit": "Visita al lugar",
  "pt.row.coordination": "Coordinación de los proveedores tras la firma del presupuesto",
  "pt.row.onsite": "Gestor de eventos in situ durante el evento (>40K€)",
  "pt.discover_fees": "Descubra nuestras tarifas",
  "pt.cta": "Descubrir la plataforma Veolia",

  "how.badge": "En 6 pasos simples",
  "how.title": "¿Cómo funciona?",
  "how.step": "Paso",
  "how.prev": "Paso anterior",
  "how.next": "Paso siguiente",
  "how.go_to": "Ir al paso",
  "how.s1.title": "Envíe su brief",
  "how.s1.desc": "Envíe su brief a su experto en eventos (vía la plataforma, por email o por teléfono) o busque en total autonomía con la barra de búsqueda.",
  "how.s1.link.platform": "Enlace a la plataforma",
  "how.s2.title": "Obtenga una respuesta rápida",
  "how.s2.desc": "Su experto en eventos responde en una hora, hace las primeras sugerencias en 2 horas y finaliza sus presupuestos en 2 días.",
  "how.s3.title": "Solicite ajustes",
  "how.s3.desc": "Solicite ajustes o nuevas propuestas. Su experto lo actualiza todo en 24 horas hasta que esté listo para confirmar su reserva.",
  "how.s4.title": "Confirme la reserva",
  "how.s4.desc": "Cuando esté satisfecho con sus presupuestos, descargue el que corresponda a sus expectativas y lance su orden de compra.",
  "how.s5.title": "Cree su orden de compra",
  "how.s5.desc": "Durante la validación de su orden de compra, haga clic en 'Confirmar la reserva' en la plataforma para descargar la factura final.",
  "how.s6.title": "Obtenga un soporte completo (opcional)",
  "how.s6.desc": "Si necesita ayuda para organizar su evento, Naboo puede ofrecerle un soporte completo hasta el día del evento.",

  "footer.terms": "Términos y condiciones de uso",
  "footer.contact": "Contáctenos",
  "footer.cookies": "Modificar sus preferencias de cookies",

  "pop.subject": "Solicitud Veolia",
  "pop.copy": "Copiar el email",
  "pop.gmail": "Abrir en Gmail",
  "pop.outlook": "Abrir en Outlook",
  "pop.mail_app": "Usar mi aplicación de correo",
  "pop.copied": "Email copiado",
  "pop.copy_error": "Imposible copiar",

  // Quiz ES
  "quiz.step.type": "Tipo",
  "quiz.step.dates": "Fechas",
  "quiz.step.categories": "Categorías",
  "quiz.step.participants": "Participantes",
  "quiz.step.standing": "Categoría",
  "quiz.step.match": "Match",
  "quiz.title.type": "¿Qué tipo de evento organiza?",
  "quiz.title.categories": "¿Qué ambiente busca?",
  "quiz.title.participants": "¿Cuántos participantes?",
  "quiz.title.standing": "¿Cuál es su presupuesto?",
  "quiz.title.dates_prefix": "¿Cuándo es su ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "evento",
  "quiz.label.0": "Tipo de evento",
  "quiz.label.1": "Fechas",
  "quiz.label.2": "Categorías",
  "quiz.label.3": "Participantes",
  "quiz.label.4": "Presupuesto",
  "quiz.label.5": "Sus datos",
  "quiz.month.0": "Enero","quiz.month.1": "Febrero","quiz.month.2": "Marzo","quiz.month.3": "Abril","quiz.month.4": "Mayo","quiz.month.5": "Junio","quiz.month.6": "Julio","quiz.month.7": "Agosto","quiz.month.8": "Septiembre","quiz.month.9": "Octubre","quiz.month.10": "Noviembre","quiz.month.11": "Diciembre",
  "quiz.evt.seminaire": "Seminario de empresa",
  "quiz.evt.journee_hors_site": "Jornada externa",
  "quiz.evt.soiree": "Fiesta de empresa",
  "quiz.evt.team_building": "Actividad de team building",
  "quiz.evt.conference": "Conferencia",
  "quiz.evt.lancement_produit": "Lanzamiento de producto",
  "quiz.evt.autre": "Otro",
  "quiz.evt.placeholder": "Indique el tipo de evento",
  "quiz.cat.Plage": "Playa","quiz.cat.Montagne": "Montaña","quiz.cat.Ville": "Ciudad","quiz.cat.Nature": "Naturaleza","quiz.cat.Désert": "Desierto","quiz.cat.Tropical": "Tropical","quiz.cat.Bord de lac": "Orilla del lago","quiz.cat.Île": "Isla","quiz.cat.Historique": "Histórico","quiz.cat.Luxe": "Lujo","quiz.cat.Aventure": "Aventura","quiz.cat.Bien-être": "Bienestar",
  "quiz.dates.placeholder": "Elegir una fecha",
  "quiz.dates.or_month": "O elija un mes",
  "quiz.participants.hint": "Número de participantes",
  "quiz.participants.placeholder": "Ej: 25",
  "quiz.budget.per_person": "es decir {p} € por persona",
  "quiz.budget.or": "O",
  "quiz.budget.placeholder": "Presupuesto total exacto",
  "quiz.budget.exact": "Introducir un importe exacto",
  "quiz.standing.Essentiel": "Esencial","quiz.standing.Confort": "Confort","quiz.standing.Premium": "Premium","quiz.standing.Prestige": "Prestigio","quiz.standing.Exception": "Excepción",
  "quiz.match.title": "Reciba sus sugerencias",
  "quiz.match.subtitle": "Indique su email profesional para recibir su selección personalizada.",
  "quiz.match.email_placeholder": "su.email@veolia.com",
  "quiz.match.cta": "Recibir mis sugerencias",
  "quiz.match.sending": "Enviando…",
  "quiz.match_suffix": "% de match",
  "quiz.email.required": "Email requerido",
  "quiz.email.invalid": "Email inválido",
  "quiz.email.pro": "Por favor, use su email profesional",
  "quiz.success.title": "¡Solicitud enviada!",
  "quiz.success.subtitle": "Célia se pondrá en contacto con usted muy pronto con una selección personalizada.",
  "quiz.success.close": "Cerrar",
  "quiz.engagement.title": "¿Cómo desea recibir sus sugerencias?",
  "quiz.engagement.subtitle": "Solo un paso más",
  "quiz.engagement.email_title": "Por email",
  "quiz.engagement.email_desc": "Directamente en su bandeja de entrada en menos de 2 horas.",
  "quiz.engagement.email_b1": "Reciba un resumen de su brief",
  "quiz.engagement.email_b2": "Obtenga recomendaciones a medida",
  "quiz.engagement.email_b3": "Reserve su evento con total autonomía",
  "quiz.engagement.email_cta": "Recibir por email",
  "quiz.engagement.rdv_title": "En una llamada con Célia",
  "quiz.engagement.rdv_desc": "Sin discurso comercial, solo recomendaciones honestas.",
  "quiz.engagement.rdv_b1": "Sin compromiso",
  "quiz.engagement.rdv_b2": "Una persona real, no un bot",
  "quiz.engagement.rdv_b3": "100 % adaptado a sus necesidades",
  "quiz.engagement.rdv_cta": "Reservar un horario",
  "quiz.engagement.rdv_modal_title": "Reservar una cita con Célia",
  "quiz.engagement.rdv_success_title": "¡Cita confirmada!",
  "quiz.engagement.rdv_success_subtitle": "Célia se pondrá en contacto con usted en el horario elegido. Una invitación está en su bandeja de entrada.",
  "quiz.nav.back": "Atrás",
  "quiz.nav.next": "Siguiente",
  "quiz.aria.close": "Cerrar",
  "quiz.tier.Petit comité": "Comité pequeño",
  "quiz.tier.Groupe convivial": "Grupo reducido",
  "quiz.tier.Grande équipe": "Equipo grande",
  "quiz.tier.Grand événement": "Gran evento",
  "quiz.tier.Événement XL": "Evento XL",

  // AI Planner
  "ai_planner.pill": "Nuevo · IA",
  "ai_planner.title": "Construyamos vuestro próximo evento",
  "ai_planner.description": "Describid vuestro evento y nuestra IA os sugerirá opciones personalizadas.",
  "ai_planner.cta": "Probar el planificador IA",
};

const en: Dict = {
  ...fr,
  "header.discuter": "Chat",
  "header.discuter_aria": "Chat with Célia",
  "header.prendre_rdv": "Book a meeting",
  "header.prendre_rdv_aria": "Book a meeting with Célia",
  "header.demande_short": "Request",
  "header.envoyer_demande": "Send my request",
  "header.plateforme_short": "Platform",
  "header.plateforme_full": "Go to the Veolia platform",
  "header.pill_role": ", your ",
  "header.pill_role_suffix": " advisor",

  "seo.title": "Naboo × Veolia — Event platform dedicated to Veolia employees",
  "seo.description": "Naboo platform reserved exclusively to Veolia employees: organise your seminars, events and team building with negotiated terms and dedicated support by Célia.",
  "seo.og.description": "Private Veolia × Naboo space: organise corporate events with negotiated rates and dedicated support.",
  "seo.og.image_alt": "Veolia and Naboo logos — Your dedicated event platform",
  "seo.twitter.title": "Naboo × Veolia — Dedicated event platform",
  "seo.twitter.description": "Private Veolia × Naboo space: seminars, events and team building with negotiated rates and a dedicated advisor.",
  "seo.twitter.image_alt": "Naboo × Veolia — Dedicated event platform",
  "seo.author": "Naboo for Veolia",
  "seo.locale": "en_GB",
  "html.lang": "en",

  "hero.title": "A few quick questions to find your ideal venue.",
  "hero.step.type": "Event type",
  "hero.step.dates": "Dates",
  "hero.step.participants": "Participants",
  "hero.step.match": "Your match",
  "hero.cta": "Start →",
  "hero.subline": "Results in under 30 sec",

  "stats.partnership_value": "7 years",
  "stats.partnership": "Partner since",
  "stats.events": "Events",
  "stats.participants": "Participants",
  "stats.colleagues": "Registered colleagues",

  "colleagues.title": "752 Veolia colleagues are already on Naboo",
  "colleagues.paragraph": "Find the history of your events, the follow-up of your ongoing projects and all your quotes in one place.",
  "colleagues.cta": "Create an account →",
  "colleagues.label": "Your colleagues already use Naboo",
  "colleagues.more": "colleagues",

  "destinations.title": "Top destinations",
  "destinations.instant": "Instant booking",
  "destinations.bottom_title": "Discover over 50,000 venues and service providers in our database",
  "destinations.bottom_subtitle": "Explore the full Naboo catalogue reserved for Veolia teams.",
  "destinations.bottom_cta": "Explore venues →",

  "push.line1": "Your ideal venue in 30 sec",
  "push.line2": "Naboo Quiz",
  "push.close": "Close",

  "events.title": "Organise any type of event, from 5 to 500 participants, anywhere in the world",
  "events.prev": "Previous",
  "events.next": "Next",
  "events.go_to": "Go to event",
  "events.stay": "Overnight retreat",
  "events.conf": "Conferences",
  "events.rooms": "Exhibitions | Fairs",
  "events.awayday": "Away-day | Meeting | Training session",
  "events.parties": "Corporate parties | Afterworks",
  "events.meals": "Business meals | Catering",
  "events.tb": "Team building activity",

  "services.title": "One platform for all your logistics",
  "services.paragraph": "From meeting rooms to bus transfers, we handle everything. You only have one contact: Célia.",
  "services.catering": "Catering & restaurants",
  "services.animation": "Speakers & entertainment",
  "services.transport": "Transport & transfers",
  "services.hotels": "Hotels & venues",
  "services.coworking": "Meeting rooms & coworking",
  "services.more": "+ any other event service on demand",

  "pt.title": "Benefit from preferential rates",
  "pt.col.invoicing": "Invoice carrying",
  "pt.col.standard": "Standard Service",
  "pt.col.turnkey": "Turnkey Service",
  "pt.group.admin": "Admin",
  "pt.group.search": "Venue finding",
  "pt.group.management": "Event management",
  "pt.row.fees": "Fees",
  "pt.row.advance": "Deposit advance payment",
  "pt.row.referencing": "Listing of new venues and providers via Naboo",
  "pt.row.autonomy": "Full autonomy on the platform",
  "pt.row.delegation": "Brief delegation to event expert with unlimited suggestions and support",
  "pt.row.assistance": "Unlimited assistance to negotiate prices and T&Cs",
  "pt.row.app": "Event app for organisers and participants",
  "pt.row.visit": "Site visit",
  "pt.row.coordination": "Coordination of providers after signing the quote",
  "pt.row.onsite": "On-site event manager during the event (>€40K)",
  "pt.discover_fees": "Discover our fees",
  "pt.cta": "Discover the Veolia platform",

  "how.badge": "In 6 simple steps",
  "how.title": "How does it work?",
  "how.step": "Step",
  "how.prev": "Previous step",
  "how.next": "Next step",
  "how.go_to": "Go to step",
  "how.s1.title": "Send your brief",
  "how.s1.desc": "Send your brief to your event expert (via the platform, email or phone) or search using the search bar in full autonomy.",
  "how.s1.link.platform": "Link to the platform",
  "how.s2.title": "Get a prompt answer",
  "how.s2.desc": "Your event expert answers within 1 hour, makes first suggestions within 2 hours, and finalises quotes within 2 days.",
  "how.s3.title": "Ask for adjustments",
  "how.s3.desc": "Ask for adjustments or new proposals. Your expert updates everything within 24 hours until you are ready to confirm. Adjustments are unlimited.",
  "how.s4.title": "Confirm booking",
  "how.s4.desc": "When you are happy with your quotes, download the one that meets your expectations and start your purchase request.",
  "how.s5.title": "Create your purchase request",
  "how.s5.desc": "While your PR is being validated, click 'Confirm booking' on the platform to download the final invoice and transform it into a PO. Naboo handles the payment.",
  "how.s6.title": "Get full support (optional)",
  "how.s6.desc": "If you need help organising your event, Naboo can provide full event manager support up until the day of the event — just ask!",

  "footer.terms": "General terms of use",
  "footer.cgu": "T&Cs",
  "footer.contact": "Contact us",
  "footer.cookies": "Change your cookie preferences",

  "pop.subject": "Veolia request",
  "pop.copy": "Copy email",
  "pop.gmail": "Open in Gmail",
  "pop.outlook": "Open in Outlook",
  "pop.mail_app": "Use my mail app",
  "pop.copied": "Email copied",
  "pop.copy_error": "Unable to copy",

  // Quiz EN
  "quiz.step.type": "Type",
  "quiz.step.dates": "Dates",
  "quiz.step.categories": "Categories",
  "quiz.step.participants": "Participants",
  "quiz.step.standing": "Standing",
  "quiz.step.match": "Match",
  "quiz.title.type": "What type of event are you organising?",
  "quiz.title.categories": "What atmosphere are you looking for?",
  "quiz.title.participants": "How many participants?",
  "quiz.title.standing": "What is your budget?",
  "quiz.title.dates_prefix": "When is your ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "event",
  "quiz.label.0": "Event type","quiz.label.1": "Dates","quiz.label.2": "Categories","quiz.label.3": "Participants","quiz.label.4": "Budget","quiz.label.5": "Your details",
  "quiz.month.0": "January","quiz.month.1": "February","quiz.month.2": "March","quiz.month.3": "April","quiz.month.4": "May","quiz.month.5": "June","quiz.month.6": "July","quiz.month.7": "August","quiz.month.8": "September","quiz.month.9": "October","quiz.month.10": "November","quiz.month.11": "December",
  "quiz.evt.seminaire": "Corporate seminar",
  "quiz.evt.journee_hors_site": "Offsite day",
  "quiz.evt.soiree": "Corporate party",
  "quiz.evt.team_building": "Team building activity",
  "quiz.evt.conference": "Conference",
  "quiz.evt.lancement_produit": "Product launch",
  "quiz.evt.autre": "Other",
  "quiz.evt.placeholder": "Specify the event type",
  "quiz.cat.Plage": "Beach","quiz.cat.Montagne": "Mountain","quiz.cat.Ville": "City","quiz.cat.Nature": "Nature","quiz.cat.Désert": "Desert","quiz.cat.Tropical": "Tropical","quiz.cat.Bord de lac": "Lakeside","quiz.cat.Île": "Island","quiz.cat.Historique": "Historic","quiz.cat.Luxe": "Luxury","quiz.cat.Aventure": "Adventure","quiz.cat.Bien-être": "Wellness",
  "quiz.dates.placeholder": "Pick a date",
  "quiz.dates.or_month": "Or pick a month",
  "quiz.participants.hint": "Number of participants",
  "quiz.participants.placeholder": "E.g. 25",
  "quiz.budget.per_person": "i.e. €{p} per person",
  "quiz.budget.or": "OR",
  "quiz.budget.placeholder": "Exact total budget",
  "quiz.budget.exact": "Enter an exact amount",
  "quiz.standing.Essentiel": "Essential","quiz.standing.Confort": "Comfort","quiz.standing.Premium": "Premium","quiz.standing.Prestige": "Prestige","quiz.standing.Exception": "Exceptional",
  "quiz.match.title": "Receive your suggestions",
  "quiz.match.subtitle": "Enter your work email to receive your personalised selection.",
  "quiz.match.email_placeholder": "your.email@veolia.com",
  "quiz.match.cta": "Get my suggestions",
  "quiz.match.sending": "Sending…",
  "quiz.match_suffix": "% match",
  "quiz.email.required": "Email required",
  "quiz.email.invalid": "Invalid email",
  "quiz.email.pro": "Please use your work email",
  "quiz.success.title": "Request sent!",
  "quiz.success.subtitle": "Célia will get back to you very shortly with a personalised selection.",
  "quiz.success.close": "Close",
  "quiz.engagement.title": "How would you like to receive your suggestions?",
  "quiz.engagement.subtitle": "One last step",
  "quiz.engagement.email_title": "By email",
  "quiz.engagement.email_desc": "Straight to your inbox within 2 hours.",
  "quiz.engagement.email_b1": "Get a recap of your brief",
  "quiz.engagement.email_b2": "Receive tailor-made recommendations",
  "quiz.engagement.email_b3": "Book your event on your own",
  "quiz.engagement.email_cta": "Receive by email",
  "quiz.engagement.rdv_title": "On a call with Célia",
  "quiz.engagement.rdv_desc": "No sales pitch, only honest recommendations.",
  "quiz.engagement.rdv_b1": "No commitment",
  "quiz.engagement.rdv_b2": "A real human, not a bot",
  "quiz.engagement.rdv_b3": "100% tailored to your needs",
  "quiz.engagement.rdv_cta": "Book a slot",
  "quiz.engagement.rdv_modal_title": "Book a slot with Célia",
  "quiz.engagement.rdv_success_title": "Appointment confirmed!",
  "quiz.engagement.rdv_success_subtitle": "Célia will contact you at the chosen time. An invitation is in your inbox.",
  "quiz.nav.back": "Back",
  "quiz.nav.next": "Next",
  "quiz.aria.close": "Close",
  "quiz.tier.Petit comité": "Small group",
  "quiz.tier.Groupe convivial": "Friendly group",
  "quiz.tier.Grande équipe": "Large team",
  "quiz.tier.Grand événement": "Large event",
  "quiz.tier.Événement XL": "XL event",

  // AI Planner
  "ai_planner.pill": "New · AI",
  "ai_planner.title": "Let's build your next event",
  "ai_planner.description": "Describe your event and our AI will suggest tailored options.",
  "ai_planner.cta": "Try the AI planner",
};

const nl: Dict = {
  ...en,
  "header.discuter": "Chatten",
  "header.discuter_aria": "Chatten met Célia",
  "header.prendre_rdv": "Afspraak maken",
  "header.prendre_rdv_aria": "Een afspraak maken met Célia",
  "header.demande_short": "Aanvraag",
  "header.envoyer_demande": "Mijn aanvraag versturen",
  "header.plateforme_short": "Platform",
  "header.plateforme_full": "Naar het Veolia-platform",
  "header.pill_role": ", uw adviseur ",
  "header.pill_role_suffix": "",

  "seo.title": "Naboo × Veolia — Eventplatform voor Veolia-medewerkers",
  "seo.description": "Naboo-platform exclusief voor Veolia-medewerkers: organiseer uw seminars, evenementen en teambuilding met onderhandelde voorwaarden en persoonlijke ondersteuning door Célia.",
  "seo.og.description": "Privé Veolia × Naboo-omgeving: organiseer bedrijfsevenementen met onderhandelde tarieven en persoonlijke ondersteuning.",
  "seo.og.image_alt": "Veolia- en Naboo-logo's — Uw eventplatform",
  "seo.twitter.title": "Naboo × Veolia — Eventplatform",
  "seo.twitter.description": "Privé Veolia × Naboo-omgeving: seminars, evenementen en teambuilding met onderhandelde tarieven.",
  "seo.twitter.image_alt": "Naboo × Veolia — Eventplatform",
  "seo.author": "Naboo voor Veolia",
  "seo.locale": "nl_NL",
  "html.lang": "nl",

  "hero.title": "Een paar snelle vragen om uw ideale locatie te vinden.",
  "hero.step.type": "Evenementtype",
  "hero.step.dates": "Data",
  "hero.step.participants": "Deelnemers",
  "hero.step.match": "Uw match",
  "hero.cta": "Starten →",
  "hero.subline": "Resultaten in minder dan 30 sec",

  "stats.partnership_value": "7 jaar",
  "stats.partnership": "Partner sinds",
  "stats.events": "Evenementen",
  "stats.participants": "Deelnemers",
  "stats.colleagues": "Geregistreerde collega's",

  "colleagues.title": "Al 752 Veolia-collega's gebruiken Naboo",
  "colleagues.paragraph": "Vind de geschiedenis van uw evenementen, de opvolging van uw lopende projecten en al uw offertes op één plek.",
  "colleagues.cta": "Account aanmaken →",
  "colleagues.label": "Uw collega's gebruiken Naboo al",
  "colleagues.more": "collega's",

  "destinations.title": "Top bestemmingen",
  "destinations.instant": "Directe boeking",
  "destinations.bottom_title": "Ontdek meer dan 50000 locaties en dienstverleners in onze database",
  "destinations.bottom_subtitle": "Ontdek de volledige Naboo-catalogus voor Veolia-teams.",
  "destinations.bottom_cta": "Locaties verkennen →",

  "push.line1": "Uw ideale locatie in 30 sec",
  "push.line2": "Naboo Quiz",
  "push.close": "Sluiten",

  "events.title": "Organiseer elk type evenement, van 5 tot 500 deelnemers, overal ter wereld",
  "events.stay": "Verblijf met overnachting",
  "events.conf": "Conferenties",
  "events.rooms": "Kamerblokreserveringen voor beurzen",
  "events.awayday": "Externe dag | Vergadering | Training",
  "events.parties": "Bedrijfsfeesten | Afterworks",
  "events.meals": "Zakelijke maaltijden | Catering",
  "events.tb": "Teambuilding",

  "services.title": "Eén platform voor al uw logistiek",
  "services.paragraph": "Van vergaderzaal tot transferbus, wij regelen alles. U heeft slechts één contactpersoon: Célia.",
  "services.catering": "Catering & restaurants",
  "services.animation": "Sprekers & entertainment",
  "services.transport": "Transport & transfers",
  "services.hotels": "Hotels & locaties",
  "services.coworking": "Vergaderruimtes & coworking",
  "services.more": "+ elke andere eventdienst op aanvraag",

  "pt.title": "Profiteer van voorkeurscondities",
  "pt.col.invoicing": "Factuurdrager",
  "pt.col.standard": "Standaard Service",
  "pt.col.turnkey": "Sleutelklare Service",
  "pt.group.admin": "Beheer",
  "pt.group.search": "Locatie zoeken",
  "pt.group.management": "Evenementenbeheer",
  "pt.row.fees": "Kosten",
  "pt.row.advance": "Vooruitbetaling borg",
  "pt.row.referencing": "Vermelding van nieuwe locaties en dienstverleners via Naboo",
  "pt.row.autonomy": "Volledige autonomie op het platform",
  "pt.row.delegation": "Onbeperkte gepersonaliseerde suggesties en ondersteuning van evenementenexpert",
  "pt.row.assistance": "Onbeperkte assistentie bij het onderhandelen over prijzen en voorwaarden",
  "pt.row.app": "App voor organisator en deelnemers",
  "pt.row.visit": "Locatiebezoek",
  "pt.row.coordination": "Coördinatie van dienstverleners na ondertekening van de offerte",
  "pt.row.onsite": "Evenementenmanager ter plaatse tijdens de gebeurtenis (>40K€)",
  "pt.discover_fees": "Ontdek onze tarieven",
  "pt.cta": "Ontdek het Veolia-platform",

  "how.badge": "In 6 eenvoudige stappen",
  "how.title": "Hoe werkt het?",
  "how.step": "Stap",
  "how.prev": "Vorige stap",
  "how.next": "Volgende stap",
  "how.go_to": "Ga naar stap",
  "how.s1.title": "Stuur uw briefing",
  "how.s1.desc": "Stuur uw briefing naar uw evenementexpert (via het platform, e-mail of telefoon) of zoek via de zoekbalk volledig zelfstandig.",
  "how.s1.link.platform": "Link naar het platform",
  "how.s2.title": "Krijg een snel antwoord",
  "how.s2.desc": "Uw evenementexpert reageert binnen 1 uur, doet de eerste suggesties binnen 2 uur en maakt uw offertes binnen 2 dagen af.",
  "how.s3.title": "Vraag om aanpassingen",
  "how.s3.desc": "Vraag om aanpassingen of nieuwe voorstellen. Uw expert werkt alles binnen 24 uur bij totdat u klaar bent om uw boeking te bevestigen. Aanpassingen zijn onbeperkt.",
  "how.s4.title": "Maak uw inkoopverzoek",
  "how.s4.desc": "Wanneer u tevreden bent met de ontvangen offertes, kunt u diegene downloaden die aan uw verwachtingen voldoet en het proces van inkoopverzoek starten.",
  "how.s5.title": "Bevestig de boeking",
  "how.s5.desc": "Terwijl uw verzoek wordt gevalideerd, klikt u op 'Boeking bevestigen' op het platform om de definitieve factuur te downloaden en het inkoopverzoek om te zetten in een inkooporder. Maakt u zich geen zorgen over de betaling – Naboo regelt alles.",
  "how.s6.title": "Krijg volledige ondersteuning (optioneel)",
  "how.s6.desc": "Mocht u hulp nodig hebben bij het organiseren van uw evenement, dan kan Naboo u voorzien van volledige ondersteuning door een evenementenmanager, tot aan de dag van het evenement. U hoeft het alleen te vragen!",

  "footer.terms": "Algemene gebruiksvoorwaarden",
  "footer.contact": "Neem contact op",
  "footer.cookies": "Wijzig uw cookievoorkeuren",

  "pop.subject": "Veolia aanvraag",
  "pop.copy": "E-mail kopiëren",
  "pop.gmail": "Openen in Gmail",
  "pop.outlook": "Openen in Outlook",
  "pop.mail_app": "Mijn e-mailapp gebruiken",
  "pop.copied": "E-mail gekopieerd",
  "pop.copy_error": "Kopiëren mislukt",

  // Quiz NL
  "quiz.step.type": "Type",
  "quiz.step.dates": "Data",
  "quiz.step.categories": "Categorieën",
  "quiz.step.participants": "Deelnemers",
  "quiz.step.standing": "Niveau",
  "quiz.step.match": "Match",
  "quiz.title.type": "Welk type evenement organiseert u?",
  "quiz.title.categories": "Welke sfeer zoekt u?",
  "quiz.title.participants": "Hoeveel deelnemers?",
  "quiz.title.standing": "Wat is uw budget?",
  "quiz.title.dates_prefix": "Wanneer vindt uw ",
  "quiz.title.dates_suffix": " plaats?",
  "quiz.title.event_word": "evenement",
  "quiz.label.0": "Type evenement","quiz.label.1": "Data","quiz.label.2": "Categorieën","quiz.label.3": "Deelnemers","quiz.label.4": "Budget","quiz.label.5": "Uw gegevens",
  "quiz.month.0": "Januari","quiz.month.1": "Februari","quiz.month.2": "Maart","quiz.month.3": "April","quiz.month.4": "Mei","quiz.month.5": "Juni","quiz.month.6": "Juli","quiz.month.7": "Augustus","quiz.month.8": "September","quiz.month.9": "Oktober","quiz.month.10": "November","quiz.month.11": "December",
  "quiz.evt.seminaire": "Bedrijfsseminar",
  "quiz.evt.journee_hors_site": "Offsite dag",
  "quiz.evt.soiree": "Bedrijfsfeest",
  "quiz.evt.team_building": "Teambuilding-activiteit",
  "quiz.evt.conference": "Conferentie",
  "quiz.evt.lancement_produit": "Productlancering",
  "quiz.evt.autre": "Anders",
  "quiz.evt.placeholder": "Geef het type evenement op",
  "quiz.cat.Plage": "Strand","quiz.cat.Montagne": "Bergen","quiz.cat.Ville": "Stad","quiz.cat.Nature": "Natuur","quiz.cat.Désert": "Woestijn","quiz.cat.Tropical": "Tropisch","quiz.cat.Bord de lac": "Aan het meer","quiz.cat.Île": "Eiland","quiz.cat.Historique": "Historisch","quiz.cat.Luxe": "Luxe","quiz.cat.Aventure": "Avontuur","quiz.cat.Bien-être": "Wellness",
  "quiz.dates.placeholder": "Kies een datum",
  "quiz.dates.or_month": "Of kies een maand",
  "quiz.participants.hint": "Aantal deelnemers",
  "quiz.participants.placeholder": "Bijv. 25",
  "quiz.budget.per_person": "ofwel € {p} per persoon",
  "quiz.budget.or": "OF",
  "quiz.budget.placeholder": "Exact totaal budget",
  "quiz.budget.exact": "Voer een exact bedrag in",
  "quiz.standing.Essentiel": "Essentieel","quiz.standing.Confort": "Comfort","quiz.standing.Premium": "Premium","quiz.standing.Prestige": "Prestige","quiz.standing.Exception": "Uitzonderlijk",
  "quiz.match.title": "Ontvang uw suggesties",
  "quiz.match.subtitle": "Voer uw zakelijke e-mail in om uw persoonlijke selectie te ontvangen.",
  "quiz.match.email_placeholder": "uw.email@veolia.com",
  "quiz.match.cta": "Mijn suggesties ontvangen",
  "quiz.match.sending": "Versturen…",
  "quiz.match_suffix": "% match",
  "quiz.email.required": "E-mail vereist",
  "quiz.email.invalid": "Ongeldige e-mail",
  "quiz.email.pro": "Gebruik uw zakelijke e-mailadres",
  "quiz.success.title": "Aanvraag verzonden!",
  "quiz.success.subtitle": "Célia neemt zeer binnenkort contact met u op met een persoonlijke selectie.",
  "quiz.success.close": "Sluiten",
  "quiz.engagement.title": "Hoe wilt u uw suggesties ontvangen?",
  "quiz.engagement.subtitle": "Nog één stap",
  "quiz.engagement.email_title": "Per e-mail",
  "quiz.engagement.email_desc": "Rechtstreeks in uw inbox binnen 2 uur.",
  "quiz.engagement.email_b1": "Ontvang een samenvatting van uw briefing",
  "quiz.engagement.email_b2": "Krijg aanbevelingen op maat",
  "quiz.engagement.email_b3": "Boek uw evenement zelfstandig",
  "quiz.engagement.email_cta": "Per e-mail ontvangen",
  "quiz.engagement.rdv_title": "In een gesprek met Célia",
  "quiz.engagement.rdv_desc": "Geen verkooppraatje, alleen eerlijke aanbevelingen.",
  "quiz.engagement.rdv_b1": "Vrijblijvend",
  "quiz.engagement.rdv_b2": "Een echte mens, geen bot",
  "quiz.engagement.rdv_b3": "100% afgestemd op uw behoeften",
  "quiz.engagement.rdv_cta": "Tijdslot reserveren",
  "quiz.engagement.rdv_modal_title": "Een afspraak maken met Célia",
  "quiz.engagement.rdv_success_title": "Afspraak bevestigd!",
  "quiz.engagement.rdv_success_subtitle": "Célia neemt op het gekozen tijdstip contact met u op. Een uitnodiging staat in uw inbox.",
  "quiz.nav.back": "Terug",
  "quiz.nav.next": "Volgende",
  "quiz.aria.close": "Sluiten",
  "quiz.tier.Petit comité": "Kleine groep",
  "quiz.tier.Groupe convivial": "Gezellige groep",
  "quiz.tier.Grande équipe": "Groot team",
  "quiz.tier.Grand événement": "Groot evenement",
  "quiz.tier.Événement XL": "XL-evenement",

  // AI Planner
  "ai_planner.pill": "Nieuw · AI",
  "ai_planner.title": "Laten we uw volgende event bouwen",
  "ai_planner.description": "Beschrijf uw event en onze AI stelt persoonlijke opties voor.",
  "ai_planner.cta": "Probeer de AI planner",
};

const de: Dict = {
  ...en,
  "header.discuter": "Chatten",
  "header.discuter_aria": "Mit Célia chatten",
  "header.prendre_rdv": "Termin buchen",
  "header.prendre_rdv_aria": "Einen Termin mit Célia buchen",
  "header.demande_short": "Anfrage",
  "header.envoyer_demande": "Anfrage senden",
  "header.plateforme_short": "Plattform",
  "header.plateforme_full": "Zur Veolia-Plattform",
  "header.pill_role": ", Ihre Beraterin ",
  "header.pill_role_suffix": "",

  "seo.title": "Naboo × Veolia — Event-Plattform für Veolia-Mitarbeiter",
  "seo.description": "Naboo-Plattform exklusiv für Veolia-Mitarbeiter: organisieren Sie Seminare, Events und Teambuilding mit verhandelten Konditionen und persönlicher Betreuung durch Célia.",
  "seo.og.description": "Privater Veolia × Naboo-Bereich: organisieren Sie Firmenevents mit verhandelten Tarifen und persönlicher Betreuung.",
  "seo.og.image_alt": "Veolia- und Naboo-Logos — Ihre Event-Plattform",
  "seo.twitter.title": "Naboo × Veolia — Event-Plattform",
  "seo.twitter.description": "Privater Veolia × Naboo-Bereich: Seminare, Events und Teambuilding mit verhandelten Tarifen.",
  "seo.twitter.image_alt": "Naboo × Veolia — Event-Plattform",
  "seo.author": "Naboo für Veolia",
  "seo.locale": "de_DE",
  "html.lang": "de",

  "hero.title": "Ein paar schnelle Fragen, um Ihre ideale Location zu finden.",
  "hero.step.type": "Eventtyp",
  "hero.step.dates": "Daten",
  "hero.step.participants": "Teilnehmende",
  "hero.step.match": "Ihr Match",
  "hero.cta": "Starten →",
  "hero.subline": "Ergebnisse in unter 30 Sek.",

  "stats.partnership_value": "7 Jahre",
  "stats.partnership": "Partner seit",
  "stats.events": "Veranstaltungen",
  "stats.participants": "Teilnehmende",
  "stats.colleagues": "Registrierte Mitarbeitende",

  "colleagues.title": "Bereits 752 Veolia-Mitarbeitende auf Naboo registriert",
  "colleagues.paragraph": "Finden Sie die Historie Ihrer Events, den Stand Ihrer laufenden Projekte und alle Ihre Angebote an einem Ort.",
  "colleagues.cta": "Konto erstellen →",
  "colleagues.label": "Diese Mitarbeitenden nutzen Naboo bereits",
  "colleagues.more": "Mitarbeitende",

  "destinations.title": "Top-Reiseziele",
  "destinations.instant": "Sofortbuchung",
  "destinations.bottom_title": "Entdecken Sie über 50000 Locations und Dienstleister in unserer Datenbank",
  "destinations.bottom_subtitle": "Erkunden Sie den gesamten Naboo-Katalog für die Veolia-Teams.",
  "destinations.bottom_cta": "Locations entdecken →",

  "push.line1": "Ihre ideale Location in 30 Sek.",
  "push.line2": "Naboo Quiz",
  "push.close": "Schließen",

  "events.title": "Organisieren Sie jede Art von Event, von 5 bis 500 Teilnehmenden, weltweit",
  "events.stay": "Aufenthalt mit Übernachtung",
  "events.conf": "Konferenzen",
  "events.rooms": "Messestände",
  "events.awayday": "Auswärtstag | Meeting | Training",
  "events.parties": "Firmenfeiern | Afterworks",
  "events.meals": "Geschäftsessen | Catering",
  "events.tb": "Teambuiliding-Aktivitäten",

  "services.title": "Eine Plattform für Ihre gesamte Logistik",
  "services.paragraph": "Vom Konferenzraum bis zum Transferbus — wir kümmern uns um alles. Sie haben nur eine Ansprechpartnerin: Célia.",
  "services.catering": "Catering & Restaurants",
  "services.animation": "Speaker & Animation",
  "services.transport": "Transport & Transfers",
  "services.hotels": "Hotels & Locations",
  "services.coworking": "Meetingräume & Coworking",
  "services.more": "+ jede weitere Eventdienstleistung auf Anfrage",

  "pt.title": "Profitieren Sie von bevorzugten Konditionen",
  "pt.col.invoicing": "Rechnungsträgerdienst",
  "pt.col.standard": "Standardservice",
  "pt.col.turnkey": "Schlüsselfertig-Service",
  "pt.group.admin": "Verwaltung",
  "pt.group.search": "Veranstaltungsortsuche",
  "pt.group.management": "Veranstaltungsmanagement",
  "pt.row.fees": "Gebühren",
  "pt.row.advance": "Anzahlung",
  "pt.row.referencing": "Listing neuer Veranstaltungsorte und Dienstleister über Naboo",
  "pt.row.autonomy": "Volle Autonomie auf der Plattform",
  "pt.row.delegation": "Briefing-Delegation an Event-Experten mit unbegrenzten Vorschlägen und Unterstützung",
  "pt.row.assistance": "Unbegrenzte Unterstützung bei der Verhandlung von Preisen und Geschäftsbedingungen",
  "pt.row.app": "Event-App für Organisatoren und Teilnehmende",
  "pt.row.visit": "Besichtigung des Veranstaltungsorts",
  "pt.row.coordination": "Koordination der Dienstleister nach Unterzeichnung des Angebots",
  "pt.row.onsite": "Event-Manager vor Ort während der Veranstaltung (>40K€)",
  "pt.discover_fees": "Entdecken Sie unsere Gebühren",
  "pt.cta": "Veolia-Plattform entdecken",

  "how.badge": "In 6 einfachen Schritten",
  "how.title": "Wie funktioniert es?",
  "how.step": "Schritt",
  "how.prev": "Vorheriger Schritt",
  "how.next": "Nächster Schritt",
  "how.go_to": "Zu Schritt gehen",
  "how.s1.title": "Senden Sie Ihr Briefing",
  "how.s1.desc": "Senden Sie Ihr Briefing an Ihren Event-Experten (über die Plattform, E-Mail oder Telefon) oder suchen Sie mit der Suchleiste in voller Autonomie.",
  "how.s1.link.platform": "Link zur Plattform",
  "how.s2.title": "Erhalten Sie eine schnelle Antwort",
  "how.s2.desc": "Ihr Event-Experte antwortet innerhalb einer Stunde, macht erste Vorschläge innerhalb von 2 Stunden und stellt Ihre Angebote innerhalb von 2 Tagen fertig.",
  "how.s3.title": "Fordern Sie Anpassungen an",
  "how.s3.desc": "Fordern Sie Anpassungen oder neue Vorschläge an. Ihr Experte aktualisiert alles innerhalb von 24 Stunden, bis Sie bereit sind, Ihre Buchung zu bestätigen. Anpassungen sind unbegrenzt.",
  "how.s4.title": "Bestätigen Sie die Buchung",
  "how.s4.desc": "Während Ihre Kaufanfrage validiert wird, klicken Sie auf 'Buchung bestätigen' auf der Plattform, um die endgültige Rechnung herunterzuladen und Ihre Kaufanfrage in eine Bestellung umzuwandeln. Keine Sorgen wegen der Zahlung, Naboo kümmert sich um alles.",
  "how.s5.title": "Erstellen Sie Ihre Kaufanfrage",
  "how.s5.desc": "Wenn Sie mit Ihren Angeboten zufrieden sind, laden Sie das Angebot herunter, das Ihren Erwartungen entspricht, und starten Sie Ihren Kaufanfrageprozess.",
  "how.s6.title": "Erhalten Sie vollständige Unterstützung (optional)",
  "how.s6.desc": "Sollten Sie Hilfe bei der Organisation Ihrer Veranstaltung benötigen, kann Naboo Ihnen bis zum Tag der Veranstaltung einen vollständigen Event-Manager-Support bieten, fragen Sie einfach!",

  "footer.terms": "Allgemeine Nutzungsbedingungen",
  "footer.contact": "Kontaktieren Sie uns",
  "footer.cookies": "Cookie-Einstellungen ändern",

  "pop.subject": "Veolia-Anfrage",
  "pop.copy": "E-Mail kopieren",
  "pop.gmail": "In Gmail öffnen",
  "pop.outlook": "In Outlook öffnen",
  "pop.mail_app": "Meine E-Mail-App nutzen",
  "pop.copied": "E-Mail kopiert",
  "pop.copy_error": "Kopieren fehlgeschlagen",

  // Quiz DE
  "quiz.step.type": "Typ",
  "quiz.step.dates": "Daten",
  "quiz.step.categories": "Kategorien",
  "quiz.step.participants": "Teilnehmende",
  "quiz.step.standing": "Niveau",
  "quiz.step.match": "Match",
  "quiz.title.type": "Welche Art von Veranstaltung organisieren Sie?",
  "quiz.title.categories": "Welche Atmosphäre suchen Sie?",
  "quiz.title.participants": "Wie viele Teilnehmende?",
  "quiz.title.standing": "Wie hoch ist Ihr Budget?",
  "quiz.title.dates_prefix": "Wann findet Ihre ",
  "quiz.title.dates_suffix": " statt?",
  "quiz.title.event_word": "Veranstaltung",
  "quiz.label.0": "Veranstaltungstyp","quiz.label.1": "Daten","quiz.label.2": "Kategorien","quiz.label.3": "Teilnehmende","quiz.label.4": "Budget","quiz.label.5": "Ihre Daten",
  "quiz.month.0": "Januar","quiz.month.1": "Februar","quiz.month.2": "März","quiz.month.3": "April","quiz.month.4": "Mai","quiz.month.5": "Juni","quiz.month.6": "Juli","quiz.month.7": "August","quiz.month.8": "September","quiz.month.9": "Oktober","quiz.month.10": "November","quiz.month.11": "Dezember",
  "quiz.evt.seminaire": "Firmenseminar",
  "quiz.evt.journee_hors_site": "Offsite-Tag",
  "quiz.evt.soiree": "Firmenfeier",
  "quiz.evt.team_building": "Teambuiliding-Aktivitäten",
  "quiz.evt.conference": "Konferenz",
  "quiz.evt.lancement_produit": "Produkteinführung",
  "quiz.evt.autre": "Andere",
  "quiz.evt.placeholder": "Veranstaltungstyp angeben",
  "quiz.cat.Plage": "Strand","quiz.cat.Montagne": "Berge","quiz.cat.Ville": "Stadt","quiz.cat.Nature": "Natur","quiz.cat.Désert": "Wüste","quiz.cat.Tropical": "Tropisch","quiz.cat.Bord de lac": "Am See","quiz.cat.Île": "Insel","quiz.cat.Historique": "Historisch","quiz.cat.Luxe": "Luxus","quiz.cat.Aventure": "Abenteuer","quiz.cat.Bien-être": "Wellness",
  "quiz.dates.placeholder": "Datum auswählen",
  "quiz.dates.or_month": "Oder einen Monat wählen",
  "quiz.participants.hint": "Anzahl der Teilnehmenden",
  "quiz.participants.placeholder": "Z. B. 25",
  "quiz.budget.per_person": "d. h. {p} € pro Person",
  "quiz.budget.or": "ODER",
  "quiz.budget.placeholder": "Exaktes Gesamtbudget",
  "quiz.budget.exact": "Genauen Betrag eingeben",
  "quiz.standing.Essentiel": "Essentiell","quiz.standing.Confort": "Komfort","quiz.standing.Premium": "Premium","quiz.standing.Prestige": "Prestige","quiz.standing.Exception": "Außergewöhnlich",
  "quiz.match.title": "Erhalten Sie Ihre Vorschläge",
  "quiz.match.subtitle": "Geben Sie Ihre geschäftliche E-Mail-Adresse ein, um Ihre persönliche Auswahl zu erhalten.",
  "quiz.match.email_placeholder": "ihre.email@veolia.com",
  "quiz.match.cta": "Meine Vorschläge erhalten",
  "quiz.match.sending": "Wird gesendet…",
  "quiz.match_suffix": "% Match",
  "quiz.email.required": "E-Mail erforderlich",
  "quiz.email.invalid": "Ungültige E-Mail",
  "quiz.email.pro": "Bitte verwenden Sie Ihre geschäftliche E-Mail-Adresse",
  "quiz.success.title": "Anfrage gesendet!",
  "quiz.success.subtitle": "Célia meldet sich in Kürze mit einer persönlichen Auswahl bei Ihnen.",
  "quiz.success.close": "Schließen",
  "quiz.engagement.title": "Wie möchten Sie Ihre Vorschläge erhalten?",
  "quiz.engagement.subtitle": "Nur noch ein Schritt",
  "quiz.engagement.email_title": "Per E-Mail",
  "quiz.engagement.email_desc": "Direkt in Ihrem Posteingang innerhalb von 2 Stunden.",
  "quiz.engagement.email_b1": "Erhalten Sie eine Zusammenfassung Ihres Briefings",
  "quiz.engagement.email_b2": "Erhalten Sie maßgeschneiderte Empfehlungen",
  "quiz.engagement.email_b3": "Buchen Sie Ihre Veranstaltung selbstständig",
  "quiz.engagement.email_cta": "Per E-Mail erhalten",
  "quiz.engagement.rdv_title": "Im Gespräch mit Célia",
  "quiz.engagement.rdv_desc": "Kein Verkaufsgespräch, nur ehrliche Empfehlungen.",
  "quiz.engagement.rdv_b1": "Unverbindlich",
  "quiz.engagement.rdv_b2": "Ein echter Mensch, kein Bot",
  "quiz.engagement.rdv_b3": "100 % auf Ihre Bedürfnisse zugeschnitten",
  "quiz.engagement.rdv_cta": "Termin reservieren",
  "quiz.engagement.rdv_modal_title": "Einen Termin mit Célia buchen",
  "quiz.engagement.rdv_success_title": "Termin bestätigt!",
  "quiz.engagement.rdv_success_subtitle": "Célia meldet sich zur gewählten Zeit. Eine Einladung liegt in Ihrem Posteingang.",
  "quiz.nav.back": "Zurück",
  "quiz.nav.next": "Weiter",
  "quiz.aria.close": "Schließen",
  "quiz.tier.Petit comité": "Kleine Gruppe",
  "quiz.tier.Groupe convivial": "Gemütliche Gruppe",
  "quiz.tier.Grande équipe": "Großes Team",
  "quiz.tier.Grand événement": "Große Veranstaltung",
  "quiz.tier.Événement XL": "XL-Veranstaltung",

  // AI Planner
  "ai_planner.pill": "Neu · KI",
  "ai_planner.title": "Lassen Sie uns Ihre nächste Veranstaltung planen",
  "ai_planner.description": "Beschreiben Sie Ihre Veranstaltung – unsere KI schlägt passende Optionen vor.",
  "ai_planner.cta": "KI-Planner ausprobieren",
};

const it: Dict = {
  ...fr,
  "header.discuter": "Chatta",
  "header.discuter_aria": "Chatta con Célia",
  "header.prendre_rdv": "Prenota un appuntamento",
  "header.prendre_rdv_aria": "Prenotare un appuntamento con Célia",
  "header.demande_short": "Richiesta",
  "header.envoyer_demande": "Invia la mia richiesta",
  "header.plateforme_short": "Piattaforma",
  "header.plateforme_full": "Accedi alla piattaforma Veolia",
  "header.pill_role": ", la vostra referente ",
  "header.pill_role_suffix": "",

  "seo.title": "Naboo × Veolia — Piattaforma eventi dedicata alle persone che lavorano in Veolia",
  "seo.description": "Piattaforma Naboo riservata esclusivamente alle persone che lavorano in Veolia: organizzate seminari, eventi e team building con condizioni negoziate e un accompagnamento dedicato da Célia.",
  "seo.og.description": "Spazio privato Veolia × Naboo: organizzate eventi aziendali con tariffe negoziate e accompagnamento dedicato.",
  "seo.og.image_alt": "Loghi Veolia e Naboo — La vostra piattaforma eventi dedicata",
  "seo.twitter.title": "Naboo × Veolia — Piattaforma eventi dedicata",
  "seo.twitter.description": "Spazio privato Veolia × Naboo: seminari, eventi e team building con tariffe negoziate e una referente dedicata.",
  "seo.twitter.image_alt": "Naboo × Veolia — Piattaforma eventi dedicata",
  "seo.author": "Naboo per Veolia",
  "seo.locale": "it_IT",
  "html.lang": "it",

  "hero.badge": "Quiz",
  "hero.title": "Alcune domande rapide per trovare la location ideale.",
  "hero.step.type": "Tipo di evento",
  "hero.step.dates": "Date",
  "hero.step.participants": "Partecipanti",
  "hero.step.match": "Il vostro match",
  "hero.cta": "Iniziare →",
  "hero.subline": "Risultati in meno di 30 sec",

  "stats.partnership_value": "7 anni",
  "stats.partnership": "Partner da",
  "stats.events": "Eventi",
  "stats.participants": "Partecipanti",
  "stats.colleagues": "Colleghe e colleghi iscritti",

  "colleagues.title": "Già 752 colleghe e colleghi Veolia iscritti su Naboo",
  "colleagues.paragraph": "Ritrovate la cronologia dei vostri eventi, il monitoraggio dei progetti in corso e tutti i preventivi in un unico posto.",
  "colleagues.cta": "Creare un account →",
  "colleagues.label": "Le vostre colleghe e i vostri colleghi usano già Naboo",
  "colleagues.more": "colleghi/e",

  "destinations.title": "Top destinazioni",
  "destinations.instant": "Prenotazione immediata",
  "destinations.bottom_title": "Scoprite oltre 50 000 location e fornitori nel nostro database",
  "destinations.bottom_subtitle": "Esplorate l'intero catalogo Naboo riservato ai team Veolia.",
  "destinations.bottom_cta": "Esplorare le location →",

  "push.line1": "La location ideale in 30 sec",
  "push.line2": "Quiz Naboo",
  "push.close": "Chiudere",

  "events.title": "Organizzate ogni tipo di evento, da 5 a 500 partecipanti, ovunque nel mondo",
  "events.prev": "Precedente",
  "events.next": "Successivo",
  "events.go_to": "Vai all'evento",
  "events.stay": "Soggiorno con pernottamento",
  "events.conf": "Conferenze",
  "events.rooms": "Prenotazione camere per fiere ed esposizioni",
  "events.awayday": "Giornata fuori sede | Riunione | Sessione di formazione",
  "events.parties": "Feste aziendali | Afterwork",
  "events.meals": "Pranzi di lavoro | Catering",
  "events.tb": "Attività di team building",

  "services.title": "Una sola piattaforma per tutta la vostra logistica",
  "services.paragraph": "Dalla sala riunioni al bus per i trasferimenti, ci occupiamo di tutto. Avete un'unica referente: Célia.",
  "services.catering": "Ristorazione e catering",
  "services.animation": "Animazione e relatori/relatrici",
  "services.transport": "Trasporti e transfer",
  "services.hotels": "Hotel e location",
  "services.coworking": "Sale e coworking",
  "services.more": "+ qualsiasi altro servizio per eventi su richiesta",

  "pt.title": "Approfittate di condizioni preferenziali",
  "pt.col.invoicing": "Gestione fatture",
  "pt.col.standard": "Servizio Standard",
  "pt.col.turnkey": "Servizio Chiavi in Mano",
  "pt.group.admin": "Amministrazione",
  "pt.group.search": "Ricerca location",
  "pt.group.management": "Gestione eventi",
  "pt.row.fees": "Costi",
  "pt.row.advance": "Anticipo cauzione",
  "pt.row.referencing": "Referenziazione di nuove location e fornitori tramite Naboo",
  "pt.row.autonomy": "Autonomia completa sulla piattaforma",
  "pt.row.delegation": "Delega del brief a una persona esperta di eventi con suggerimenti e supporto illimitati",
  "pt.row.assistance": "Assistenza illimitata per negoziare prezzi e condizioni",
  "pt.row.app": "App eventi per chi organizza e per chi partecipa",
  "pt.row.visit": "Visita del sito",
  "pt.row.coordination": "Coordinamento dei fornitori dopo la firma del preventivo",
  "pt.row.onsite": "Event manager in loco durante l'evento (>40K€)",
  "pt.discover_fees": "Scoprite i nostri costi",
  "pt.cta": "Scoprire la piattaforma Veolia",

  "how.badge": "In 6 semplici passaggi",
  "how.title": "Come funziona?",
  "how.step": "Passaggio",
  "how.prev": "Passaggio precedente",
  "how.next": "Passaggio successivo",
  "how.go_to": "Vai al passaggio",
  "how.s1.title": "Inviate il vostro brief",
  "how.s1.desc": "Inviate il vostro brief alla persona esperta di eventi (tramite la piattaforma, via email o per telefono) o cercate in autonomia con la barra di ricerca.",
  "how.s1.link.platform": "Link alla piattaforma",
  "how.s2.title": "Ricevete una risposta rapida",
  "how.s2.desc": "La persona esperta di eventi risponde entro un'ora, fornisce i primi suggerimenti entro 2 ore e finalizza i preventivi entro 2 giorni.",
  "how.s3.title": "Richiedete modifiche",
  "how.s3.desc": "Richiedete modifiche o nuove proposte. Il team aggiorna tutto entro 24 ore finché non siete pronti a confermare. Le modifiche sono illimitate.",
  "how.s4.title": "Confermate la prenotazione",
  "how.s4.desc": "Quando siete soddisfatti dei preventivi, scaricate quello che corrisponde alle vostre aspettative e avviate il vostro processo di richiesta d'acquisto.",
  "how.s5.title": "Create la richiesta d'acquisto",
  "how.s5.desc": "Durante la convalida della richiesta, cliccate su 'Conferma prenotazione' sulla piattaforma per scaricare la fattura finale e trasformare la richiesta in ordine d'acquisto. Naboo si occupa di tutto.",
  "how.s6.title": "Ricevete un supporto completo (opzionale)",
  "how.s6.desc": "Se avete bisogno di aiuto per organizzare l'evento, Naboo può fornirvi un supporto completo fino al giorno dell'evento, basta chiedere!",

  "footer.terms": "Condizioni generali d'uso",
  "footer.cgu": "CGU",
  "footer.contact": "Contattateci",
  "footer.cookies": "Modificare le preferenze cookie",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  "pop.subject": "Richiesta Veolia",
  "pop.copy": "Copiare l'email",
  "pop.gmail": "Aprire in Gmail",
  "pop.outlook": "Aprire in Outlook",
  "pop.mail_app": "Usare la mia app di posta",
  "pop.copied": "Email copiata",
  "pop.copy_error": "Impossibile copiare",

  "quiz.match.email_placeholder": "tua.email@veolia.com",
  "quiz.success.subtitle": "Célia tornerà presto da voi con una selezione personalizzata.",

  // Quiz
  "quiz.step.type": "Tipo",
  "quiz.step.dates": "Date",
  "quiz.step.categories": "Categorie",
  "quiz.step.participants": "Partecipanti",
  "quiz.step.standing": "Livello",
  "quiz.step.match": "Match",
  "quiz.title.type": "Che tipo di evento state organizzando?",
  "quiz.title.categories": "Che atmosfera state cercando?",
  "quiz.title.participants": "Quante persone parteciperanno?",
  "quiz.title.standing": "Qual è il vostro budget?",
  "quiz.title.dates_prefix": "Quando si svolge il vostro ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "evento",
  "quiz.label.0": "Tipo di evento",
  "quiz.label.1": "Date",
  "quiz.label.2": "Categorie",
  "quiz.label.3": "Partecipanti",
  "quiz.label.4": "Budget",
  "quiz.label.5": "I vostri contatti",
  "quiz.month.0": "Gennaio",
  "quiz.month.1": "Febbraio",
  "quiz.month.2": "Marzo",
  "quiz.month.3": "Aprile",
  "quiz.month.4": "Maggio",
  "quiz.month.5": "Giugno",
  "quiz.month.6": "Luglio",
  "quiz.month.7": "Agosto",
  "quiz.month.8": "Settembre",
  "quiz.month.9": "Ottobre",
  "quiz.month.10": "Novembre",
  "quiz.month.11": "Dicembre",
  "quiz.evt.seminaire": "Seminario aziendale",
  "quiz.evt.journee_hors_site": "Giornata offsite",
  "quiz.evt.soiree": "Serata aziendale",
  "quiz.evt.team_building": "Attività di team building",
  "quiz.evt.conference": "Conferenza",
  "quiz.evt.lancement_produit": "Lancio di prodotto",
  "quiz.evt.autre": "Altro",
  "quiz.evt.placeholder": "Specificate il tipo di evento",
  "quiz.cat.Plage": "Spiaggia",
  "quiz.cat.Montagne": "Montagna",
  "quiz.cat.Ville": "Città",
  "quiz.cat.Nature": "Natura",
  "quiz.cat.Désert": "Deserto",
  "quiz.cat.Tropical": "Tropicale",
  "quiz.cat.Bord de lac": "Sul lago",
  "quiz.cat.Île": "Isola",
  "quiz.cat.Historique": "Storico",
  "quiz.cat.Luxe": "Lusso",
  "quiz.cat.Aventure": "Avventura",
  "quiz.cat.Bien-être": "Benessere",
  "quiz.dates.placeholder": "Scegliere una data",
  "quiz.dates.or_month": "Oppure scegliere un mese",
  "quiz.participants.hint": "Numero di partecipanti",
  "quiz.participants.placeholder": "Es. 25",
  "quiz.budget.per_person": "ovvero {p} € a persona",
  "quiz.budget.or": "OPPURE",
  "quiz.budget.placeholder": "Budget totale esatto",
  "quiz.budget.exact": "Inserire un importo esatto",
  "quiz.standing.Essentiel": "Essenziale",
  "quiz.standing.Confort": "Comfort",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestigio",
  "quiz.standing.Exception": "Eccezionale",
  "quiz.match.title": "Ricevete i vostri suggerimenti",
  "quiz.match.subtitle": "Indicate la vostra email professionale per ricevere una selezione personalizzata.",
  "quiz.match.cta": "Ricevere i miei suggerimenti",
  "quiz.match.sending": "Invio in corso…",
  "quiz.match_suffix": "% di match",
  "quiz.email.required": "Email richiesta",
  "quiz.email.invalid": "Email non valida",
  "quiz.email.pro": "Si prega di utilizzare la vostra email professionale",
  "quiz.success.title": "Richiesta inviata!",
  "quiz.success.close": "Chiudere",
  "quiz.engagement.title": "Come desiderate ricevere i vostri suggerimenti?",
  "quiz.engagement.subtitle": "Manca solo un passo",
  "quiz.engagement.email_title": "Per email",
  "quiz.engagement.email_desc": "Direttamente nella vostra casella entro 2 ore.",
  "quiz.engagement.email_b1": "Ricevete un riepilogo del vostro brief",
  "quiz.engagement.email_b2": "Ottenete raccomandazioni su misura",
  "quiz.engagement.email_b3": "Prenotate il vostro evento in autonomia",
  "quiz.engagement.email_cta": "Ricevere via email",
  "quiz.engagement.rdv_title": "Durante una chiamata con Célia",
  "quiz.engagement.rdv_desc": "Nessun discorso commerciale, solo raccomandazioni oneste.",
  "quiz.engagement.rdv_b1": "Senza impegno",
  "quiz.engagement.rdv_b2": "Una persona vera, non un bot",
  "quiz.engagement.rdv_b3": "100 % adatto alle vostre esigenze",
  "quiz.engagement.rdv_cta": "Prenotare uno slot",
  "quiz.engagement.rdv_modal_title": "Prenotare un appuntamento con Célia",
  "quiz.engagement.rdv_success_title": "Appuntamento confermato!",
  "quiz.engagement.rdv_success_subtitle": "Célia vi contatterà all'orario scelto. Un invito è nella vostra casella di posta.",
  "quiz.nav.back": "Indietro",
  "quiz.nav.next": "Avanti",
  "quiz.aria.close": "Chiudere",
  "quiz.tier.Petit comité": "Piccolo gruppo",
  "quiz.tier.Groupe convivial": "Gruppo conviviale",
  "quiz.tier.Grande équipe": "Grande team",
  "quiz.tier.Grand événement": "Grande evento",
  "quiz.tier.Événement XL": "Evento XL",

  // AI Planner
  "ai_planner.pill": "Nuovo · IA",
  "ai_planner.title": "Costruiamo il vostro prossimo evento",
  "ai_planner.description": "Descrivete il vostro evento e la nostra IA suggerirà opzioni personalizzate.",
  "ai_planner.cta": "Provare l'IA planner",
};

const pt: Dict = {
  ...fr,
  "header.discuter": "Conversar",
  "header.discuter_aria": "Conversar com Célia",
  "header.prendre_rdv": "Marcar reunião",
  "header.prendre_rdv_aria": "Marcar uma reunião com Célia",
  "header.demande_short": "Pedido",
  "header.envoyer_demande": "Enviar o meu pedido",
  "header.plateforme_short": "Plataforma",
  "header.plateforme_full": "Aceder à plataforma Veolia",
  "header.pill_role": ", a vossa consultora ",
  "header.pill_role_suffix": "",

  "seo.title": "Naboo × Veolia — Plataforma de eventos dedicada às pessoas que trabalham na Veolia",
  "seo.description": "Plataforma Naboo reservada exclusivamente às pessoas que trabalham na Veolia: organize seminários, eventos e team building com condições negociadas e um acompanhamento dedicado por Célia.",
  "seo.og.description": "Espaço privado Veolia × Naboo: organize eventos corporativos com tarifas negociadas e acompanhamento dedicado.",
  "seo.og.image_alt": "Logos Veolia e Naboo — A vossa plataforma de eventos dedicada",
  "seo.twitter.title": "Naboo × Veolia — Plataforma de eventos dedicada",
  "seo.twitter.description": "Espaço privado Veolia × Naboo: seminários, eventos e team building com tarifas negociadas e uma consultora dedicada.",
  "seo.twitter.image_alt": "Naboo × Veolia — Plataforma de eventos dedicada",
  "seo.author": "Naboo para Veolia",
  "seo.locale": "pt_PT",
  "html.lang": "pt",

  "hero.badge": "Quiz",
  "hero.title": "Algumas perguntas rápidas para encontrar o local ideal.",
  "hero.step.type": "Tipo de evento",
  "hero.step.dates": "Datas",
  "hero.step.participants": "Participantes",
  "hero.step.match": "O vosso match",
  "hero.cta": "Começar →",
  "hero.subline": "Resultados em menos de 30 seg",

  "stats.partnership_value": "7 anos",
  "stats.partnership": "Parceiros desde",
  "stats.events": "Eventos",
  "stats.participants": "Participantes",
  "stats.colleagues": "Colegas inscritos/as",

  "colleagues.title": "Já 752 colegas Veolia inscritos/as na Naboo",
  "colleagues.paragraph": "Encontre o histórico dos vossos eventos, o acompanhamento dos projetos em curso e todos os orçamentos no mesmo sítio.",
  "colleagues.cta": "Criar uma conta →",
  "colleagues.label": "As vossas colegas e os vossos colegas já usam Naboo",
  "colleagues.more": "colegas",

  "destinations.title": "Destinos em destaque",
  "destinations.instant": "Reserva instantânea",
  "destinations.bottom_title": "Descubra mais de 50 000 locais e fornecedores na nossa base de dados",
  "destinations.bottom_subtitle": "Explore todo o catálogo Naboo reservado às equipas Veolia.",
  "destinations.bottom_cta": "Explorar os locais →",

  "push.line1": "O local ideal em 30 seg",
  "push.line2": "Quiz Naboo",
  "push.close": "Fechar",

  "events.title": "Organize qualquer tipo de evento, de 5 a 500 participantes, em qualquer lugar do mundo",
  "events.prev": "Anterior",
  "events.next": "Seguinte",
  "events.go_to": "Ir para o evento",
  "events.stay": "Estadia com pernoita",
  "events.conf": "Conferências",
  "events.rooms": "Reserva de quartos para feiras e exposições",
  "events.awayday": "Dia externo | Reunião | Sessão de formação",
  "events.parties": "Festas de empresa | Afterworks",
  "events.meals": "Refeições de negócios | Catering",
  "events.tb": "Atividade de team building",

  "services.title": "Uma única plataforma para toda a vossa logística",
  "services.paragraph": "Da sala de reunião ao autocarro de transferência, tratamos de tudo. Têm uma única interlocutora: Célia.",
  "services.catering": "Restauração e catering",
  "services.animation": "Animação e oradores/as",
  "services.transport": "Transportes e transferências",
  "services.hotels": "Hotéis e locais",
  "services.coworking": "Salas e coworking",
  "services.more": "+ qualquer outro serviço de eventos a pedido",

  "pt.title": "Beneficie de condições preferenciais",
  "pt.col.invoicing": "Gestão de faturas",
  "pt.col.standard": "Serviço Padrão",
  "pt.col.turnkey": "Serviço Chave na Mão",
  "pt.group.admin": "Administração",
  "pt.group.search": "Procura de local",
  "pt.group.management": "Gestão de eventos",
  "pt.row.fees": "Taxas",
  "pt.row.advance": "Adiantamento de sinal",
  "pt.row.referencing": "Referenciação de novos locais e fornecedores através da Naboo",
  "pt.row.autonomy": "Autonomia total na plataforma",
  "pt.row.delegation": "Delegação do brief a uma pessoa especialista em eventos com sugestões e apoio ilimitados",
  "pt.row.assistance": "Assistência ilimitada para negociar preços e condições",
  "pt.row.app": "Aplicação para quem organiza e quem participa",
  "pt.row.visit": "Visita ao local",
  "pt.row.coordination": "Coordenação dos fornecedores após assinatura do orçamento",
  "pt.row.onsite": "Gestor/a de eventos no local durante o evento (>40K€)",
  "pt.discover_fees": "Descubra as nossas taxas",
  "pt.cta": "Descobrir a plataforma Veolia",

  "how.badge": "Em 6 passos simples",
  "how.title": "Como funciona?",
  "how.step": "Passo",
  "how.prev": "Passo anterior",
  "how.next": "Passo seguinte",
  "how.go_to": "Ir para o passo",
  "how.s1.title": "Envie o vosso brief",
  "how.s1.desc": "Envie o brief à pessoa especialista em eventos (pela plataforma, e-mail ou telefone) ou pesquise com total autonomia usando a barra de pesquisa.",
  "how.s1.link.platform": "Link para a plataforma",
  "how.s2.title": "Obtenha uma resposta rápida",
  "how.s2.desc": "A pessoa especialista responde numa hora, faz as primeiras sugestões em 2 horas e finaliza os orçamentos em 2 dias.",
  "how.s3.title": "Peça ajustes",
  "how.s3.desc": "Peça ajustes ou novas propostas. A equipa atualiza tudo em 24 horas até estar pronto/a para confirmar. Os ajustes são ilimitados.",
  "how.s4.title": "Confirme a reserva",
  "how.s4.desc": "Quando estiver satisfeito/a com os orçamentos, descarregue o que corresponde às suas expectativas e inicie o pedido de compra.",
  "how.s5.title": "Crie o pedido de compra",
  "how.s5.desc": "Durante a validação do pedido de compra, clique em 'Confirmar reserva' na plataforma para descarregar a fatura final e transformar o pedido em ordem de compra. A Naboo trata de tudo.",
  "how.s6.title": "Receba um apoio completo (opcional)",
  "how.s6.desc": "Se precisar de ajuda para organizar o evento, a Naboo pode dar apoio completo de gestão de eventos até ao dia do evento, basta pedir!",

  "footer.terms": "Termos gerais de utilização",
  "footer.cgu": "Termos",
  "footer.contact": "Contacte-nos",
  "footer.cookies": "Alterar as preferências de cookies",
  "footer.linkedin": "LinkedIn",
  "footer.instagram": "Instagram",
  "footer.email": "Email",

  "pop.subject": "Pedido Veolia",
  "pop.copy": "Copiar o email",
  "pop.gmail": "Abrir no Gmail",
  "pop.outlook": "Abrir no Outlook",
  "pop.mail_app": "Usar a minha aplicação de email",
  "pop.copied": "Email copiado",
  "pop.copy_error": "Não foi possível copiar",

  "quiz.match.email_placeholder": "o.seu.email@veolia.com",
  "quiz.success.subtitle": "A Célia entrará em contacto consigo em breve com uma seleção personalizada.",

  // Quiz
  "quiz.step.type": "Tipo",
  "quiz.step.dates": "Datas",
  "quiz.step.categories": "Categorias",
  "quiz.step.participants": "Participantes",
  "quiz.step.standing": "Nível",
  "quiz.step.match": "Match",
  "quiz.title.type": "Que tipo de evento está a organizar?",
  "quiz.title.categories": "Que ambiente procura?",
  "quiz.title.participants": "Quantas pessoas vão participar?",
  "quiz.title.standing": "Qual é o seu orçamento?",
  "quiz.title.dates_prefix": "Quando se realiza o seu ",
  "quiz.title.dates_suffix": "?",
  "quiz.title.event_word": "evento",
  "quiz.label.0": "Tipo de evento",
  "quiz.label.1": "Datas",
  "quiz.label.2": "Categorias",
  "quiz.label.3": "Participantes",
  "quiz.label.4": "Orçamento",
  "quiz.label.5": "Os seus contactos",
  "quiz.month.0": "Janeiro",
  "quiz.month.1": "Fevereiro",
  "quiz.month.2": "Março",
  "quiz.month.3": "Abril",
  "quiz.month.4": "Maio",
  "quiz.month.5": "Junho",
  "quiz.month.6": "Julho",
  "quiz.month.7": "Agosto",
  "quiz.month.8": "Setembro",
  "quiz.month.9": "Outubro",
  "quiz.month.10": "Novembro",
  "quiz.month.11": "Dezembro",
  "quiz.evt.seminaire": "Seminário de empresa",
  "quiz.evt.journee_hors_site": "Dia offsite",
  "quiz.evt.soiree": "Festa de empresa",
  "quiz.evt.team_building": "Atividade de team building",
  "quiz.evt.conference": "Conferência",
  "quiz.evt.lancement_produit": "Lançamento de produto",
  "quiz.evt.autre": "Outro",
  "quiz.evt.placeholder": "Indique o tipo de evento",
  "quiz.cat.Plage": "Praia",
  "quiz.cat.Montagne": "Montanha",
  "quiz.cat.Ville": "Cidade",
  "quiz.cat.Nature": "Natureza",
  "quiz.cat.Désert": "Deserto",
  "quiz.cat.Tropical": "Tropical",
  "quiz.cat.Bord de lac": "Junto ao lago",
  "quiz.cat.Île": "Ilha",
  "quiz.cat.Historique": "Histórico",
  "quiz.cat.Luxe": "Luxo",
  "quiz.cat.Aventure": "Aventura",
  "quiz.cat.Bien-être": "Bem-estar",
  "quiz.dates.placeholder": "Escolher uma data",
  "quiz.dates.or_month": "Ou escolher um mês",
  "quiz.participants.hint": "Número de participantes",
  "quiz.participants.placeholder": "Ex.: 25",
  "quiz.budget.per_person": "ou seja, {p} € por pessoa",
  "quiz.budget.or": "OU",
  "quiz.budget.placeholder": "Orçamento total exato",
  "quiz.budget.exact": "Indicar um valor exato",
  "quiz.standing.Essentiel": "Essencial",
  "quiz.standing.Confort": "Conforto",
  "quiz.standing.Premium": "Premium",
  "quiz.standing.Prestige": "Prestígio",
  "quiz.standing.Exception": "Excecional",
  "quiz.match.title": "Receba as suas sugestões",
  "quiz.match.subtitle": "Indique o seu email profissional para receber uma seleção personalizada.",
  "quiz.match.cta": "Receber as minhas sugestões",
  "quiz.match.sending": "A enviar…",
  "quiz.match_suffix": "% de match",
  "quiz.email.required": "Email obrigatório",
  "quiz.email.invalid": "Email inválido",
  "quiz.email.pro": "Utilize, por favor, o seu email profissional",
  "quiz.success.title": "Pedido enviado!",
  "quiz.success.close": "Fechar",
  "quiz.engagement.title": "Como deseja receber as suas sugestões?",
  "quiz.engagement.subtitle": "Falta apenas um passo",
  "quiz.engagement.email_title": "Por email",
  "quiz.engagement.email_desc": "Diretamente na sua caixa em menos de 2 horas.",
  "quiz.engagement.email_b1": "Receba um resumo do seu briefing",
  "quiz.engagement.email_b2": "Obtenha recomendações à medida",
  "quiz.engagement.email_b3": "Reserve o seu evento com total autonomia",
  "quiz.engagement.email_cta": "Receber por email",
  "quiz.engagement.rdv_title": "Numa chamada com a Célia",
  "quiz.engagement.rdv_desc": "Sem discurso comercial, apenas recomendações honestas.",
  "quiz.engagement.rdv_b1": "Sem compromisso",
  "quiz.engagement.rdv_b2": "Uma pessoa real, não um bot",
  "quiz.engagement.rdv_b3": "100 % adaptado às suas necessidades",
  "quiz.engagement.rdv_cta": "Reservar um horário",
  "quiz.engagement.rdv_modal_title": "Marcar uma reunião com a Célia",
  "quiz.engagement.rdv_success_title": "Reunião confirmada!",
  "quiz.engagement.rdv_success_subtitle": "A Célia entrará em contacto consigo no horário escolhido. Um convite está na sua caixa de entrada.",
  "quiz.nav.back": "Voltar",
  "quiz.nav.next": "Seguinte",
  "quiz.aria.close": "Fechar",
  "quiz.tier.Petit comité": "Pequeno grupo",
  "quiz.tier.Groupe convivial": "Grupo convivial",
  "quiz.tier.Grande équipe": "Grande equipa",
  "quiz.tier.Grand événement": "Grande evento",
  "quiz.tier.Événement XL": "Evento XL",

  // AI Planner
  "ai_planner.pill": "Novo · IA",
  "ai_planner.title": "Vamos construir o seu próximo evento",
  "ai_planner.description": "Descreva o seu evento e a nossa IA sugerirá opções personalizadas.",
  "ai_planner.cta": "Experimentar o planeador IA",
};

const dicts: Record<Lang, Dict> = { fr, es, nl, de, en, it, pt };

export function detectLang(pathname: string): Lang {
  if (pathname.startsWith("/it")) return "it";
  if (pathname.startsWith("/pt")) return "pt";
  if (pathname.startsWith("/es")) return "es";
  if (pathname.startsWith("/nl")) return "nl";
  if (pathname.startsWith("/de")) return "de";
  if (pathname.startsWith("/en")) return "en";
  if (pathname.startsWith("/fr")) return "fr";
  return "en";
}

export function useArkemaLang() {
  const { pathname, search } = useLocation();
  const lang = detectLang(pathname);
  const t = (key: string): string => dicts[lang][key] ?? dicts.en[key] ?? key;
  const switchPath = (target: Lang): string => `/${target}${search || ""}`;
  return { lang, t, switchPath };
}

export function getT(lang: Lang) {
  return (key: string): string => dicts[lang][key] ?? dicts.en[key] ?? key;
}
